var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import Cookies from 'js-cookie';
import { ELSRestClientHelper, ELSCommonUIConstants } from '@els/els-ui-common-react';
import { facadeApi, tokenServiceApi } from 'helpers/api.helper';
import { ConditionSection, TrueStatement, FalseStatement, ELSIconV2 } from 'components/common';
import { EXTERNAL_APP_INFO } from 'constants/externalApp.constant';
import { CS_APP_NAME, EAB_APP_NAME, FeatureFlagNames, X_LINK_ID_COOKIE, X_TOKEN_COOKIE } from 'constants/app.constant';
import { ASSIGNMENT_TYPE_GROUPS, ASSIGNMENT_TYPES } from 'reports/cw/constants/report.constant';
import { onKeyDownHandler } from 'helpers/ui.helper';
import LinkButton from 'components/common/link-button/LinkButton';
import { isFeatureEnabled } from './feature-flag.service';
import { windowLocationAssignWrapper } from './method-wrapper.service';
import { BreadcrumbItem } from '../components/common/breadcrumb';
import { ServerConstants } from '../config/server.constant';
// "altSrcApp" is the appId where we want to back to after going to "targetApp" with app-linking.
// Ex: "targetApp" is EAQ --> we will go to the EAQ app. Then from the EAQ app we want to back to "altSrcApp".
export var getAppLinkOut = function (linkConfig, options) {
    var targetApp = linkConfig.appName, action = linkConfig.action, isIncludeLinkHash = linkConfig.isIncludeLinkHash, _a = linkConfig.altSrcApp, altSrcApp = _a === void 0 ? ELSCommonUIConstants.appIds.PERFORMANCE_REPORT : _a;
    var removeCookiesAppLink = function () {
        Cookies.remove(X_TOKEN_COOKIE, { path: '/', domain: ServerConstants[ServerConstants.DataSource].cookiesDomain });
        Cookies.remove(X_TOKEN_COOKIE, { path: '/', domain: ServerConstants[ServerConstants.DataSource].cookiesDomainWithApps });
        Cookies.remove(X_LINK_ID_COOKIE, { path: '/', domain: ServerConstants[ServerConstants.DataSource].cookiesDomain });
        Cookies.remove(X_LINK_ID_COOKIE, { path: '/', domain: ServerConstants[ServerConstants.DataSource].cookiesDomainWithApps });
    };
    removeCookiesAppLink();
    if (isIncludeLinkHash) {
        return facadeApi.post("/app-link/out/".concat(targetApp, "/").concat(action, "?includeLinkHash=true&altSrcApp=").concat(altSrcApp), options);
    }
    return facadeApi.post("/app-link/out/".concat(targetApp, "/").concat(action, "?altSrcApp=").concat(altSrcApp), options);
};
export var getNewTokenForCourseSwitcher = function (body) {
    return facadeApi.post('/sherpath/course-management/courseSections/switch', {
        data: body
    });
};
export var fetchSessionDataFromExternalApp = function (linkId) {
    return ELSRestClientHelper.get("".concat(EXTERNAL_APP_INFO.APP_LINK_DATA_API, "/").concat(linkId));
};
export var fetchDataBackToExternalApp = function (linkId) {
    if (linkId) {
        return ELSRestClientHelper.post("".concat(EXTERNAL_APP_INFO.APP_LINK_RETURN_API, "/").concat(linkId));
    }
    return Promise.reject(new Error('Invalid link id value: argument must be a non-null string'));
};
export var fetchAppLinkHashData = function (linkHash) {
    if (linkHash) {
        var option = {
            headers: {
                'X-App-ID': EXTERNAL_APP_INFO.APP_LINKING.QUAD.APP_NAME
            }
        };
        return ELSRestClientHelper.get("".concat(EXTERNAL_APP_INFO.APP_LINK_HASH_API, "/").concat(linkHash), option);
    }
    return Promise.reject(new Error('Invalid link hash value: argument must be a non-null string'));
};
export var redirectToOutsideApp = function (linkConfig_1, options_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([linkConfig_1, options_1], args_1, true), Promise, function (linkConfig, options, _getAppLinkOut) {
        var appName, isNewTab, restOptions, headers, customOptions, url;
        var _a, _b;
        if (_getAppLinkOut === void 0) { _getAppLinkOut = getAppLinkOut; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    appName = linkConfig.appName;
                    isNewTab = options.isNewTab, restOptions = __rest(options, ["isNewTab"]);
                    headers = (_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : {};
                    if (appName === EXTERNAL_APP_INFO.APP_LINKING.SHADOW_HEALTH.APP_NAME) {
                        headers['cache-control'] = 'no-store, no-cache, max-age=0, must-revalidate';
                    }
                    customOptions = __assign(__assign({}, restOptions), { headers: headers });
                    return [4 /*yield*/, _getAppLinkOut(linkConfig, customOptions)];
                case 1:
                    url = _c.sent();
                    if ((_b = url === null || url === void 0 ? void 0 : url.data) === null || _b === void 0 ? void 0 : _b.redirectUrl) {
                        windowLocationAssignWrapper(url.data.redirectUrl, isNewTab);
                    }
                    return [2 /*return*/];
            }
        });
    });
};
export var shouldRenderAssignmentDetailAppLinkUrl = function (assignmentType, featureFlags, groupId, isInstructor) {
    var _a;
    if (isInstructor === void 0) { isInstructor = true; }
    var isAssignmentDetailAppLinkEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_ASSIGNMENT_DETAIL_APP_LINK_ENABLED, groupId);
    if (!isAssignmentDetailAppLinkEnabled) {
        return false;
    }
    var isEABLinked = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_ASSIGNMENT_DETAIL_LINK_TO_EAB_ENABLED, groupId);
    var isOsmosisLinked = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_ASSIGNMENT_DETAIL_LINK_TO_OSMOSIS_ENABLED, groupId);
    return (((_a = ASSIGNMENT_TYPES[assignmentType]) === null || _a === void 0 ? void 0 : _a.isLinkedToOutsideApp) ||
        (isEABLinked && assignmentType === ASSIGNMENT_TYPES.PERSONAL_ASSESSMENT_BUILDER.id) ||
        (isOsmosisLinked && assignmentType === ASSIGNMENT_TYPES.OSMOSIS_VIDEO.id) ||
        (isInstructor && assignmentType === ASSIGNMENT_TYPES.INTERACTIVE_REVIEW.id));
};
export var buildLinkConfig = function (assignmentConfig) {
    if (ASSIGNMENT_TYPES[assignmentConfig.type].group === ASSIGNMENT_TYPE_GROUPS.EAQ) {
        if (assignmentConfig.type === ASSIGNMENT_TYPES.AUTHESS.id) {
            return {
                appName: EXTERNAL_APP_INFO.APP_LINKING.AUTHESS.APP_NAME,
                action: EXTERNAL_APP_INFO.APP_LINKING.AUTHESS.ACTION.ASSIGNMENT_PERFORMANCE_VIEW,
                isIncludeLinkHash: true
            };
        }
        if (assignmentConfig.isEnabledAMAAssignment) {
            return {
                appName: EXTERNAL_APP_INFO.APP_LINKING.ASSIGNMENT_MANAGEMENT.APP_NAME,
                action: EXTERNAL_APP_INFO.APP_LINKING.ASSIGNMENT_MANAGEMENT.ACTION.ASSIGNMENT_PERFORMANCE_VIEW
            };
        }
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.EAQ.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.EAQ.ACTION.ASSIGNMENT_PERFORMANCE_VIEW
        };
    }
    if (assignmentConfig.type === ASSIGNMENT_TYPES.ADAPTIVE_LESSON.id) {
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.KNOWLEDGE_CARD.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.KNOWLEDGE_CARD.ACTION.ASSIGNMENT_PERFORMANCE_VIEW
        };
    }
    if (assignmentConfig.type === ASSIGNMENT_TYPES.CHART.id || assignmentConfig.type === ASSIGNMENT_TYPES.CASE_STUDY.id) {
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.SIMSNG.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.SIMSNG.ACTION.ASSIGNMENT_PERFORMANCE_VIEW
        };
    }
    if (assignmentConfig.type === ASSIGNMENT_TYPES.SHADOW_HEALTH.id) {
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.SHADOW_HEALTH.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.SHADOW_HEALTH.ACTION.ASSIGNMENT_PERFORMANCE_VIEW,
            isIncludeLinkHash: true
        };
    }
    if (assignmentConfig.type === ASSIGNMENT_TYPES.PERSONAL_ASSESSMENT_BUILDER.id) {
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.PERSONAL_ASSESSMENT_BUILDER.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.PERSONAL_ASSESSMENT_BUILDER.ACTION.ASSIGNMENT_PERFORMANCE_VIEW,
            isIncludeLinkHash: true
        };
    }
    if (assignmentConfig.type === ASSIGNMENT_TYPES.LESSONS.id) {
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.SHER_EVOL.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.SHER_EVOL.ACTION.ASSIGNMENT_PERFORMANCE_VIEW,
            isIncludeLinkHash: true
        };
    }
    if (assignmentConfig.type === ASSIGNMENT_TYPES.OSMOSIS_VIDEO.id) {
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.OSMOSIS_VIDEO.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.OSMOSIS_VIDEO.ACTION.ASSIGNMENT_PERFORMANCE_VIEW,
            isIncludeLinkHash: true
        };
    }
    if (assignmentConfig.type === ASSIGNMENT_TYPES.INTERACTIVE_REVIEW.id) {
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.ASSIGNMENT_MANAGEMENT.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.ASSIGNMENT_MANAGEMENT.ACTION.ASSIGNMENT_PERFORMANCE_VIEW,
            isIncludeLinkHash: true
        };
    }
    if (assignmentConfig.type === ASSIGNMENT_TYPES.SLS_PRE_SIMULATION_QUIZ.id ||
        assignmentConfig.type === ASSIGNMENT_TYPES.SLS_POST_SIMULATION_QUIZ.id ||
        assignmentConfig.type === ASSIGNMENT_TYPES.SLS_SIMCHART_SIMULATION_EHR.id ||
        assignmentConfig.type === ASSIGNMENT_TYPES.SLS_JOURNALING_EXERCISE.id) {
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.ASSIGNMENT_MANAGEMENT.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.ASSIGNMENT_MANAGEMENT.ACTION.ASSIGNMENT_PREVIEW,
            isIncludeLinkHash: true
        };
    }
    var SHEREVOLTypes = [ASSIGNMENT_TYPES.SKILL.id, ASSIGNMENT_TYPES.SIMULATION.id, ASSIGNMENT_TYPES.LESSONS.id];
    if (SHEREVOLTypes.includes(ASSIGNMENT_TYPES[assignmentConfig.type].id)) {
        return {
            appName: EXTERNAL_APP_INFO.APP_LINKING.SHER_EVOL.APP_NAME,
            action: EXTERNAL_APP_INFO.APP_LINKING.SHER_EVOL.ACTION.ASSIGNMENT_PERFORMANCE_VIEW
        };
    }
    return { appName: '', action: '' };
};
export var renderAppLinkingAssignmentName = function (_a) {
    var assignmentConfig = _a.assignmentConfig, assignmentType = _a.assignmentType, body = _a.body, handleRedirectToOutsideApp = _a.handleRedirectToOutsideApp, _b = _a.isCWUpdateUIEnabled, isCWUpdateUIEnabled = _b === void 0 ? false : _b;
    var linkConfig = buildLinkConfig(assignmentConfig);
    var finalBody = __assign({ assignmentId: parseInt(assignmentConfig.id, 10) }, body);
    return (<span role="button" tabIndex={0} className="c-els-link" onClick={function () { return handleRedirectToOutsideApp(linkConfig, finalBody, assignmentType); }} onKeyDown={function (evt) { return onKeyDownHandler(evt, function () { return handleRedirectToOutsideApp(linkConfig, finalBody, assignmentType); }); }} title={assignmentConfig.name}>
      <ConditionSection condition={isCWUpdateUIEnabled}>
        <TrueStatement>
          <ELSIconV2 sprite="UpRight" size="s" textAlignment="offset" isVisible isTextFirst>
            {assignmentConfig.name}
          </ELSIconV2>
        </TrueStatement>
        <FalseStatement>{assignmentConfig.name}</FalseStatement>
      </ConditionSection>
    </span>);
};
export var renderCourseNameBreadcrumb = function (courseName, xLinkId, isBackToPreviousAppIconShown, handleBackPreviousAppIconClick) {
    return (<BreadcrumbItem>
      {xLinkId && isBackToPreviousAppIconShown ? (<LinkButton className="c-breadcrumb-link" type="container" onClick={function () { return handleBackPreviousAppIconClick(); }}>
          <span>{courseName}</span>
        </LinkButton>) : (courseName)}
    </BreadcrumbItem>);
};
export var isEABAppByAppName = function (appName) {
    return appName === EAB_APP_NAME;
};
export var isCSAppByAppName = function (appName) {
    return appName === CS_APP_NAME;
};
export var refreshToken = function () {
    return tokenServiceApi.post('/refresh');
};
export var getDemoToken = function (currentUser, token) { return __awaiter(void 0, void 0, Promise, function () {
    var appParams, userId, id, role, payload;
    return __generator(this, function (_a) {
        appParams = currentUser.appParams, userId = currentUser.userId, id = currentUser.id, role = currentUser.role;
        payload = {
            headers: {
                Authorization: "Bearer ".concat(token)
            },
            data: {
                user: {
                    id: userId || id,
                    role: role
                },
                appParams: __assign(__assign({}, appParams), { isMaskUserData: true })
            }
        };
        return [2 /*return*/, tokenServiceApi.post('/masqueradeWithAppParams', payload)];
    });
}); };
